export default {
  title: '主题流程说明',
  mindMap: '思维导图',
  documentTitle: '{name} 主题流程说明',
  introduction: '本文档完整列出主题中的场景判定条件、条件之间的并且/或者关系和过关动作。动作按动作条顺序输出，并保留每条动作的延时、参数和动作描述。',
  task: '任务 {id}',
  mainTask: '主任务',
  unassignedScenes: '未分配任务场景',
  scene: '场景 {id}',
  unnamedScene: '未命名场景',
  sceneDescription: '场景描述：{description}',
  nextScenes: '后续场景：{scenes}',
  sceneTiming: '进入后延时判定：{delay} 秒；超时：{timeout} 秒；超时自动跳关：{skip}',
  yes: '是',
  no: '否',
  none: '无',
  and: '并且',
  or: '或者',
  notConfigured: '未配置',
  noCondition: '未配置条件',
  noConditionGroup: '未配置条件组',
  noPassCondition: '未配置判定条件',
  noPassConditionSentence: '未配置判定条件。',
  noAction: '未配置动作',
  noActionSentence: '未配置动作。',
  noPassAction: '未配置过关动作',
  noPassActionSentence: '未配置过关动作。',
  passConditions: '过关判定条件',
  passCheck: '过关判定',
  passActions: '过关动作',
  action: '动作',
  actionBar: '动作条',
  conditionalAction: '条件动作',
  conditionalPassAction: '过关条件动作',
  trueActionBar: '满足条件动作条',
  falseActionBar: '不满足条件动作条',
  conditionMet: '满足条件',
  conditionNotMet: '不满足条件',
  executionCondition: '执行条件：{condition}',
  condition: '条件 {id}：{condition}',
  nextConditionRelation: '；与下一条件{relation}',
  delay: '（延时 {seconds} 秒）',
  colon: '：',
  comma: '，',
  semicolon: '；',
  actionSeparator: '、',
  parentheses: '（{text}）',
  quote: '“{text}”',
  conditionText: '{device}{operation}',
  operationParameter: '{operation}{parameter}',
  deviceAction: '“{device}”{operation}',
  unknownDevice: '设备未识别',
  unknownAction: '未识别动作',
  unknownCondition: '未识别的条件：{condition}',
  emptyCondition: '空条件',
  specifiedState: '达到指定状态',
  targetScene: '目标场景为“{name}”（场景 {id}）',
  parameterValue: '参数值',
  brightness: '亮度值',
  volume: '音量值',
  priority: '优先级',
  namedParameter: '{name}为“{value}”',
  additionalParameter: '参数附加值为“{value}”',
  parameterTarget: '参数目标标识为“{value}”',
  parameterHint: '参数说明为“{hint}”',
  priorityHint: '数值越大越高',
  languageHint: '0 默认，1中文，2粤语，3英语，4日语，5韩语',
  actionDescription: '；动作描述为“{description}”',
  nextSceneDescription: '下一关',
  noScenes: '当前主题没有可导出的场景',
  waitForScenes: '当前主题没有可导出的场景，请等待主题数据加载完成',
  wordExported: '主题流程说明 Word 文档已导出',
  xmindExported: '主题流程思维导图已导出',
  exportFailed: '导出主题流程失败，请稍后重试',
}
